import { useRef, useState } from "react";
import { AdStatus } from "../../../../../models";
import confirmModal from "../../../../../services/confirmModal";
import ReactGA from "react-ga4";

export const useAdPrice = (ad, shouldShowDiscountPromoTooltip, onPriceChange) => {

  const [isEditingPrice, setIsEditingPrice] = useState(false);
  const [editPriceValue, setEditPriceValue] = useState("");
  const [editPriceToValue, setEditPriceToValue] = useState("");
  const isPriceChangeTriggeredFromCTA = useRef(false)
  const wasDiscountPromoEventTriggered = useRef(false)
  const [tooltipVisible, setTooltipVisible] = useState(shouldShowDiscountPromoTooltip);


  const onEditPriceStart = () => {
    setEditPriceValue(String(ad.price));
    setEditPriceToValue(ad.priceTo ? String(ad.priceTo) : "");
    setIsEditingPrice(true);
  };

  const onEditPriceCancel = () => {
    setIsEditingPrice(false);
    setEditPriceValue("");
    setEditPriceToValue("");
    isPriceChangeTriggeredFromCTA.current = false
  };


  const onEditPriceSave = () => {
    const newPrice = parseFloat(editPriceValue.replace(",", "."));
    const newPriceTo = editPriceToValue ? parseFloat(editPriceToValue.replace(",", ".")) : null;

    if (isNaN(newPrice) || newPrice <= 0) {
      onEditPriceCancel();
      return;
    }
    if (newPriceTo !== null && (isNaN(newPriceTo) || newPriceTo <= 0)) {
      onEditPriceCancel();
      return;
    }

    if (newPriceTo !== null && newPrice > newPriceTo) {
      onEditPriceCancel();
      return;
    }

    const priceChanged = newPrice !== ad.price;
    const priceToChanged = newPriceTo !== (ad.priceTo || null);

    if (!priceChanged && !priceToChanged) {
      onEditPriceCancel();
      return;
    }

    confirmModal.show({
      title: "Promjena cijene",
      okText: "U redu",
      cancelText: "Otkaži",
      iconType: "NaN",
      onOk() {
        const priceData: any = { price: newPrice };
        if (ad.priceTo || newPriceTo) {
          priceData.priceTo = newPriceTo || 0;
        }
        onPriceChange(ad.id, ad.module, priceData);
        setIsEditingPrice(false);
        setEditPriceValue("");
        setEditPriceToValue("");

        if (isPriceChangeTriggeredFromCTA.current) {
          ReactGA.event({
            category: "Snižena cijena",
            action: "Click",
            label: "Uspješan CTA na Moji Oglasi"
          });
        }
      },
      onCancel() {
        // keep editing state so user can adjust
      },
      children: "Jeste li sigurni da želite promijeniti cijenu?"
    });
  };


  return {
    onEditPriceStart,
    onEditPriceCancel,
    isEditingPrice,
    onEditPriceSave,
    editPriceValue,
    setEditPriceValue,
    editPriceToValue,
    setEditPriceToValue,
    canEditPrice: ad.status === AdStatus.active && !ad.externalId,
    isPriceChangeTriggeredFromCTA,
    wasDiscountPromoEventTriggered,
    tooltipVisible,
    setTooltipVisible
  }
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/hooks/useAdPrice.ts